import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { AuthProvider } from "./lib/auth";
import { ThemeProvider } from "./components/ThemeProvider";
import { TooltipProvider } from "./components/ui/tooltip";
import App from "./App";
import "@fontsource-variable/inter";
import "./index.css";

// Guard against the CDN double-module problem:
// If Replit's CDN re-injects a modulepreload <link> with a different ?v=
// parameter, the browser treats it as a distinct module URL and evaluates
// this file twice.  Two createRoot() calls on the same #root element would
// mount two React trees, rendering every page twice.
//
// The guard uses a data attribute on the DOM element itself (shared across
// all module instances) so the second evaluation is a no-op even when the
// two instances have completely separate module-level variable scopes.
const rootEl = document.getElementById("root")!;
if (!rootEl.dataset.reactMounted) {
  rootEl.dataset.reactMounted = "1";
  createRoot(rootEl).render(
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
